import React from 'react'

import * as S from './styled'

export function SocialIcons() {
  return (
    <S.SocialIconsWrapper>
      <ul>
        <li>
          <a
            href="https://www.linkedin.com/company/axur"
            target="_blank"
            rel="noreferrer"
            aria-label="Link para Linkedin"
          >
            <S.LinkedinIcon />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/AxurBrasil/"
            target="_blank"
            rel="noreferrer"
            aria-label="Link para Facebook"
          >
            <S.FacebookIcon />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/axurbr/" target="_blank" rel="noreferrer" aria-label="Link para Instagram">
            <S.InstagramIcon />
          </a>
        </li>

        <li>
          <a
            href="https://www.youtube.com/c/AxurBrasil"
            target="_blank"
            rel="noreferrer"
            aria-label="Link para Youtube"
          >
            <S.YoutubeIcon />
          </a>
        </li>

        <li>
          <a
            href="https://open.spotify.com/show/6lCnGKy1D8HvKutsx3Xt5F"
            target="_blank"
            rel="noreferrer"
            aria-label="Link para Spotfy"
          >
            <S.SpotifyIcon />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/AxurBrasil/" target="_blank" rel="noreferrer" aria-label="Link para Twitter">
            <S.TwitterIcon />
          </a>
        </li>

        <li>
          <a href="https://axur.medium.com/" target="_blank" rel="noreferrer" aria-label="Link para Medium">
            <S.MediumIcon />
          </a>
        </li>
      </ul>
    </S.SocialIconsWrapper>
  )
}
